import React, { useEffect, useState } from 'react'
import { useDispatch, connect } from 'react-redux'
import { GetUserDailyScanCount } from '../../data-store/actions/FinalScan'
import { Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  counter: {
    color: theme.palette.primary.main,
    fontVariant: 'all-petite-caps'
  }
}))

const ScannedPackageCounter = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [packageTypeCount, setPackageTypeCount] = useState(0)

  useEffect(() => {
    dispatch(GetUserDailyScanCount())
  }, [])

  // There is a possibility that the page will load before this number
  // can be retrieved. We don't want to display a 'undefined' package count
  // to the user.
  useEffect(() => {
    if (props.packageTypeCount) {
      setPackageTypeCount(props.packageTypeCount)
    }
  }, [props.packageTypeCount])

  useEffect(() => {
    if (props.scanSuccess || props.stuffSuccess) {
      dispatch(GetUserDailyScanCount())
    }
  }, [props.scanSuccess, props.stuffSuccess])

  return (
    <Typography classes={{ root: classes.counter }}>
      {`${props.counterLabel}: ${packageTypeCount} `}
    </Typography>
  )
}

ScannedPackageCounter.propTypes = {
  scanSuccess: PropTypes.bool,
  stuffSuccess: PropTypes.bool
}

const mapStateToProps = (state) => {
  return {
    scanSuccess: state.finalScan.scanSuccess,
    stuffSuccess: state.stuff.scanSuccess
  }
}

export default connect(mapStateToProps)(ScannedPackageCounter)
